<template>
  <div
    id="news"
    class="content-news-section"
  >
    <b-container class="news-container">
      <div
        class="news-lists"
        :style="themeStyle"
      >
        <div
          v-if="configData.bulletin.news.length > 0"
          class="wrapper"
        >
          <div class="tabs">
            <label
              v-for="newData,index in configData.bulletin.news"
              :id="`${newData.title}-tab`"
              :key="index"
              class="tab"
              :class="{checked: index === selectedTab}"
              @click="selectedTab = index"
            >
              {{ newData.title }}
              <picture v-if="newData.state === 'new'">
                <source
                  :srcset="require('@/assets/images/items/new.webp')"
                  type="image/webp"
                >
                <img
                  :src="require('@/assets/images/items/new.png')"
                  width="30"
                  style="position: absolute; right: 0; top: 0;"
                  alt="最新消息"
                >
                <!-- style="margin-top: -10px; margin-left: -10px;" -->
              </picture>
              <picture v-else-if="newData.state === 'hot'">
                <source
                  :srcset="require('@/assets/images/items/fire2.webp')"
                  type="image/webp"
                >
                <img
                  :src="require('@/assets/images/items/fire2.png')"
                  width="20"
                  style="margin-top: -6px"
                  alt="熱門消息"
                >
              </picture>
            </label>
          </div>

          <div class="panels">
            <!-- 遊戲公告 -->
            <div
              v-for="(tableData,index) in tableDatas"
              :id="`panel-${index}`"
              :key="index"
              class="panel"
              :class="{show: selectedTab === index}"
            >
              <div>
                <table
                  v-if="tableData && tableData.forums.length > 0"
                  class="panel-table"
                >
                  <tr
                    v-for="item in tableData.forums"
                    :key="item.id"
                    @click="redirectLink(item)"
                  >
                    <td class="panel-table-title">
                      <router-link
                        :to="{
                          name: 'article',
                          params: {
                            'article_name': item.title,
                            'article_id': item.id,
                          },
                        }"
                      >
                        {{ item.title ? item.title : '---' }}
                      </router-link>
                    </td>

                    <td class="panel-table-time">
                      <div class="text-nowrap text-right">
                        {{ item.last_updated_at ? dayjs(item.last_updated_at).format('YYYY-MM-DD') : '---' }}
                      </div>
                    </td>

                  </tr>
                </table>

                <div
                  v-else-if="!tableData"
                  class="table-content-nodata"
                >
                  <!-- <b-img
                    :src="require('@/assets/images/items/loading-2.png')"
                    width="60"
                    alt="Loading"
                  /> -->
                  <loading />
                </div>

                <div
                  v-else
                  class="table-content-nodata"
                >
                  <div v-if="configData.base.notFound && configData.base.notFound.image">
                    <picture>
                      <source
                        :srcset="`${baseUrl}${webpImage(configData.base.notFound.image)}`"
                        type="image/webp"
                      >
                      <b-img
                        :src="`${baseUrl}${configData.base.notFound.image}`"
                        fluid
                        alt="查無資料"
                      />
                    </picture>
                  </div>
                  <div
                    v-else
                    class="nodata-default-img"
                  >
                    <picture>
                      <source
                        :srcset="require('@/assets/images/items/image.webp')"
                        type="image/webp"
                      >
                      <b-img
                        :src="require('@/assets/images/items/image.png')"
                        height="100"
                        alt="查無資料"
                      />
                    </picture>
                    <div class="text-center mt-2">
                      暫無資料(圖片)
                      <br>
                      建議：300X250
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="no-news"
        >
          暫無設定公告
        </div>
      </div>
      <div
        v-if="configData.area2.buttons.length > 0"
        class="area-2"
        :style="area2Style"
      >
        <template-button
          v-for="btn, index in configData.area2.buttons"
          :key="index"
          :btn-config="btn"
        />
      </div>
      <template-empty-area
        v-else
        :area-name="'板塊(二)'"
      />
    </b-container>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BContainer, BImg, // BRow, BCol,
} from 'bootstrap-vue'

import dayjs from 'dayjs'

import TemplateButton from '../component/TemplateButton.vue'
import TemplateEmptyArea from '../component/TemplateEmptyArea.vue'
// import axios from '@axios'
import loading from '@/layouts/components/Loading.vue'

import store from '@/store'

export default {
  components: {
    BContainer,
    // BRow,
    // BCol,
    BImg,

    TemplateButton,
    TemplateEmptyArea,
    loading,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
      area2Style: null,
      selectedTab: 0,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
  },
  mounted() {
    this.themeStyle = this.configData.bulletin.config
    this.area2Style = this.configData.area2.config
  },
  methods: {
    dayjs,
    // (網頁)跳轉
    redirectLink(item) {
      const url = `${window.location.origin}/article/${item.title}-a.${item.id}.html`
      window.location.assign(url)
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
  setup(props) {
    const tableDatas = ref([])
    const { classData } = store.state.api
    if (props.configData.bulletin.news.length > 0) {
      const newsApi = props.configData.bulletin.news.map(data => data.api)
      tableDatas.value = newsApi.map(item => {
        const classIndex = classData.findIndex(el => el.id === item)
        return classData[classIndex]
      })
    }
    return {
      tableDatas,
    }
  },
}
</script>

<style lang="scss" scoped>
$background-color: var(--background-color);
$primary-color: var(--primary-color);
$secondary-color: var(--secondary-color);
$text-color: var(--text-color);
$hover-color: var(--hover-color);
$radius: var(--background-radius);
$border-color: var(--border-color);
$border-style: var(--border-style);
$border-width: var(--border-width);
$bulletin-padding: var(--bulletin-padding);

.news-container {
  padding: 0;
}
.news-lists {
  padding: 0;
  height: 450px;
  .wrapper {
    display: flex;
    flex-direction: column;
    background-color: $background-color;
    border-radius: $radius;
    height: 100%;
    padding: 10px;
  }
  .no-news {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $background-color;
    border-radius: $radius;
    height: 100%;
    padding: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
  }

  .tab {
    position: relative;
    cursor: pointer;
    padding: 10px 20px;
    margin: 0px 2px;
    display: inline-block;
    color: $secondary-color;
    background-color: $background-color;
    font-size: 16px;
    border-radius: $radius $radius 0 0;
    &.checked {
      color: $secondary-color;
      background-color: $primary-color !important;
      img {
        opacity: 1;
        display: inherit;
      }
      &:hover {
        color: $secondary-color;
      }
    }
  }

  .tab:hover {
    color: $primary-color;
    background-color: $hover-color;
    cursor: pointer;
  }

  .panels {
    // border-top: 2px solid #8f8f8f76;
    height: 100%;
    width: 100%;
    border-radius: 3px;
    overflow: scroll;
    padding: $bulletin-padding;
    position: relative;
  }

  .panel {
    display: none;
    animation: fadein 0.8s;
    .panel-table {
      // background-color: red;
      width:100%;
      color: $text-color;
      font-size: 20px;
      .panel-table-title {
        width: 100%;
        max-width: 40vw;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      tr:hover {
        background-color: $hover-color;
        color: rgb(255, 145, 0);
        cursor: pointer;
      }
      td {
        display: table-cell;
        padding: .25em .5em;
        padding: 1em !important;
        margin: .5em 1em;
        text-align: left;
        font-size: 16px;
        border-bottom: $border-color $border-style $border-width;
        // border-bottom: 2px solid yellow;
        a {
          color: $text-color;
        }
      }

      .panel-table-time {
        color: $text-color;
      }
    }

    .table-content-nodata {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 300px;
      }
    }
    &.show {
      display: block;
    }
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  #one ~ .tabs #one-tab {
    img {
      opacity: 0;
      display: none;
    }
  }
}

.nodata-default-img{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  min-width: 250px;
  color: #000;
  border: 3px dashed #1d1d1d;
  border-radius: 10px;
  background-color: transparent;
}

.area-2 {
  display: flex;
  flex-wrap: wrap;
  padding: var(--padding);
  margin: var(--margin);
}

@media (max-width: 992px) {
  .news-images {
    .news-images-carousel {
      background-color: rgba(36, 36, 36, 0.8);
      padding: 10px 10px 0 10px;
      // padding-bottom: 10px;
      border-radius: 10px;
      img {
        min-height: auto;
        max-height: 450px;
      }
    }
  }

  .news-lists {
    .wrapper {
      border-radius: 10px;
    }
  }
}

@media (max-width: 768px) {
  .news-lists {
    height: 380px;
  }
}

@media (max-width: 576px) {
  .news-lists {
    .tab {
      font-size: 16px;
      img {
        width: 20px;
      }
      padding: 8px 10px;
    }

    .panels {
      padding: 0;
    }

    .panel {
      .panel-table {
        td {
          font-size: 12px;
          // padding: 8px 10px;
        }
      }
    }
  }

  .news-images {
    .carousel-slide {
      min-height: 180px;
    }
  }
}

@media (max-width: 1300px) and (min-width: 992px) {
.tab {
    padding: 5px 8px;
    font-size: 14px;
  }
}
</style>
